import { bgvStatus, bgvStatusValues, davStatusLabels, davStatusValues } from '../views/common-ui-components/sow/bgv-api/dbMapping';
import { ConstantOwnershipTypeLabels, ConstantOwnershipTypes, ConstantRelationshipTypeLabels, ConstantRelationshipTypes, DigitalAddressTypeLabels, DigitalAddressTypes, PortalUserRoles, PortalUserRolesDisplayText, invoiceTypes } from './constants';

export const idTypes = [
  {
    value: 'aadhar',
    label: 'Aadhar Card'
  },
  {
    value: 'dl',
    label: 'Driving Licence'
  },
  {
    value: 'voterid',
    label: 'Voter Id'
  },
  {
    value: 'passport',
    label: 'Passport'
  },
  {
    value: 'pan',
    label: 'Pan Card'
  },
  {
    value: 'nationalid',
    label: 'National Id'
  }
];

export const componentsArray = [
  { value: '', label: 'Select a component' },
  { value: 'Identification', label: 'Identification' },
  { value: 'Address', label: 'Address' },
  { value: 'DigitalAddress', label: 'DigitalAddress' },
  { value: 'CibilCheck', label: 'Cibil Check' },
  { value: 'CompanyCheck', label: 'Company Check' },
  { value: 'CreditCheck', label: 'Credit Check' },
  { value: 'Criminal', label: 'Criminal' },
  { value: 'CvValidation', label: 'Cv Validation' },
  { value: 'DatabaseCheck', label: 'Database Check' },
  { value: 'DirectorshipCheck', label: 'Directorship Check' },
  { value: 'DrugTest', label: 'Drug Test' },
  { value: 'OFAC', label: 'OFAC' },  // newly added
  { value: 'Education', label: 'Education' },
  { value: 'Employment', label: 'Employment' },
  { value: 'GapVerification', label: 'Gap Verification' },
  { value: 'UanCheck', label: 'UanCheck', color: 'black' },
  { value: 'PoliceVerification', label: 'Police Verification' },
  { value: 'Reference', label: 'Reference' },
  { value: 'SocialMedia', label: 'Social Media' }
];

export const addressTypeOptions = [
  { value: '', label: 'Select an option' },
  { value: DigitalAddressTypes.Permanent, label: 'Permanent' },
  { value: DigitalAddressTypes.Current, label: 'Current' }
  // { value: 'Intermediate1', label: 'Intermediate1' },
  // { value: 'Intermediate2', label: 'Intermediate2' }
];

export const addressTypeOptionsArray = ['Permanent', 'Current'];

export const dbEvidenceTypeOptions = [
  { value: '', label: 'Select an option' },
  { value: 'IndiaSpecific', label: 'India-specific Database Checks' },
  { value: 'Global', label: 'Global Database Checks' },
  { value: 'WebAndMedia', label: 'Web and Media Checks' }
];

export const dbEvidenceTypeOptionsArray = ['IndiaSpecific', 'Global', 'WebAndMedia'];

// Verification part -----------------------------------------------------

export const verificationOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Verified to be correct', label: 'Verified to be correct' },
  { value: 'Verified to be incorrect', label: 'Verified to be incorrect' }
];

// this should match the verificationOptions.value
export const verificationOptionsArray = ['Verified to be correct', 'Verified to be incorrect'];

export const evidenceUploadStatusOptions = [
  { value: '', label: 'Select an option' },
  { value: bgvStatusValues.Awaiting, label: bgvStatus.Awaiting },
  { value: bgvStatusValues.Wip, label: bgvStatus.Wip },
  { value: bgvStatusValues.Completed, label: bgvStatus.Completed },
  { value: bgvStatusValues.UnableToVerify, label: bgvStatus.UnableToVerify },
  { value: bgvStatusValues.Insufficient, label: bgvStatus.Insufficient },
  { value: bgvStatusValues.Discrepancy, label: bgvStatus.Discrepancy },
  { value: bgvStatusValues.BgvStop, label: bgvStatus.BgvStop },
  { value: bgvStatusValues.NotProvided, label: bgvStatus.NotProvided },
  { value: bgvStatusValues.PartiallyCompleted, label: bgvStatus.PartiallyCompleted },
  { value: bgvStatusValues.InsuffCleared, label: bgvStatus.InsuffCleared },
];

export const davStatusOptions = [
  { value: '', label: 'Select an option' },
  { value: bgvStatusValues.Awaiting, label: bgvStatus.Awaiting },
  { value: bgvStatusValues.Wip, label: bgvStatus.Wip },
  { value: bgvStatusValues.Completed, label: bgvStatus.Completed },
  { value: bgvStatusValues.UnableToVerify, label: bgvStatus.UnableToVerify },
  { value: bgvStatusValues.Insufficient, label: bgvStatus.Insufficient },
  { value: bgvStatusValues.Discrepancy, label: bgvStatus.Discrepancy },
  { value: bgvStatusValues.BgvStop, label: bgvStatus.BgvStop },
];

export const indivDavStatusOptions = [
  { value: '', label: 'Select an option' },
  { value: davStatusValues.Awaiting, label: davStatusLabels.Awaiting },
  { value: davStatusValues.Wip, label: davStatusLabels.Wip },
  { value: davStatusValues.Submitted, label: davStatusLabels.Submitted },
  { value: davStatusValues.ReInitiated, label: davStatusLabels.ReInitiated },
  { value: davStatusValues.Completed, label: davStatusLabels.Completed },
  { value: davStatusValues.UnableToVerify, label: davStatusLabels.UnableToVerify },
  { value: davStatusValues.Discrepancy, label: davStatusLabels.Discrepancy },
  { value: davStatusValues.Insufficient, label: davStatusLabels.Insufficient },
];

export const evidenceUploadStatusOptionsArray = [
  bgvStatusValues.Awaiting,
  bgvStatusValues.Wip,
  bgvStatusValues.Completed,
  bgvStatusValues.UnableToVerify,
  bgvStatusValues.Insufficient,
  bgvStatusValues.Discrepancy,
  bgvStatusValues.BgvStop,
  bgvStatusValues.NotProvided,
  bgvStatusValues.PartiallyCompleted,
  bgvStatusValues.InsuffCleared,
];

export const verificationStatusOptions = [
  { value: '', label: 'Select an option' },
  { value: bgvStatusValues.Completed, label: bgvStatus.Completed },
  { value: bgvStatusValues.UnableToVerify, label: bgvStatus.UnableToVerify },
  { value: bgvStatusValues.Insufficient, label: bgvStatus.Insufficient },
  { value: bgvStatusValues.Discrepancy, label: bgvStatus.Discrepancy }
];

export const verificationStatusOptionsArray = [
  bgvStatusValues.Completed,
  bgvStatusValues.UnableToVerify,
  bgvStatusValues.Insufficient,
  bgvStatusValues.Discrepancy
];

export const statusToAppearInReport = [
  bgvStatusValues.Completed,
  bgvStatusValues.Discrepancy,
  bgvStatusValues.UnableToVerify,
  bgvStatusValues.Insufficient
];

export const evidenceFileAvailabilityOptionsArray = [
  bgvStatusValues.Completed,
  bgvStatusValues.UnableToVerify,
  bgvStatusValues.Discrepancy
];

export const verificationTypeOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Police', label: 'Police' }
];

export const verificationTypeOptionsArray = ['Police'];

export const verificationModeOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Written', label: 'Written' }
];

export const verificationModeOptionsArray = ['Written'];

export const eligibleForRehireOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: 'NA', label: 'NA' }
];

// this should match the eligibleForRehireOptions.value
export const eligibleForRehireOptionsArray = ['Yes', 'No', 'NA'];

export const YesNoOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
];

export const YesNoArray = ['Yes', 'No'];

export const modeOfVerificationOptions = [
  { value: '', label: 'Select an option' },
  { value: 'E-Communication', label: 'E-Communication' },
  { value: 'Online', label: 'Online' },
  { value: 'Liaison', label: 'Liaison' },
  { value: 'Personal Visit', label: 'Personal Visit' }
];

export const employeeGender = [
  { value: '', label: 'Select an option' },
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
];

// this should match the modeOfVerificationOptions.value
export const modeOfVerificationOptionsArray = ['E-Communication', 'Online', 'Liaison', 'Personal Visit'];

export const foundNotFoundOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Found', label: 'Found' },
  { value: 'Not Found', label: 'Not Found' }
];

// this should match the foundNotFoundOptions.value
export const foundNotFoundOptionsArray = ['Found', 'Not Found'];

export const contactRelationshipOptions = [
  { value: '', label: 'Select an option' },
  { value: 'Colleague', label: 'Colleague' },
  { value: 'Friend', label: 'Friend' },
  { value: 'Others', label: 'Others' }
];

export const DigitalAddressTypeOptions = [
  { label: DigitalAddressTypeLabels.Permanent, value: DigitalAddressTypes.Permanent },
  { label: DigitalAddressTypeLabels.Current, value: DigitalAddressTypes.Current },
  { label: DigitalAddressTypeLabels.IntermediateOne, value: DigitalAddressTypes.IntermediateOne },
  { label: DigitalAddressTypeLabels.IntermediateTwo, value: DigitalAddressTypes.IntermediateTwo }
];

export const OwnershipTypeOptions = [
  { label: 'Select an option', value: '' },
  { label: ConstantOwnershipTypeLabels.Rented, value: ConstantOwnershipTypes.Rented },
  { label: ConstantOwnershipTypeLabels.Owned, value: ConstantOwnershipTypes.Owned },
  { label: ConstantOwnershipTypeLabels.Leased, value: ConstantOwnershipTypes.Leased },
  { label: ConstantOwnershipTypeLabels.PG, value: ConstantOwnershipTypes.PG },
  { label: ConstantOwnershipTypeLabels.Other, value: ConstantOwnershipTypes.Other }
];

export const RelationshipTypeOptions = [
  { label: 'Select an option', value: '' },
  { label: ConstantRelationshipTypeLabels.Self, value: ConstantRelationshipTypes.Self },
  { label: ConstantRelationshipTypeLabels.BloodRelative, value: ConstantRelationshipTypes.BloodRelative },
  { label: ConstantRelationshipTypeLabels.Spouse, value: ConstantRelationshipTypes.Spouse },
  { label: ConstantRelationshipTypeLabels.Neighbour, value: ConstantRelationshipTypes.Neighbour },
  { label: ConstantRelationshipTypeLabels.Other, value: ConstantRelationshipTypes.Other }
];

// this should match the contactRelationshipOptions.value
export const contactRelationshipOptionsArray = ['Colleague', 'Friend', 'Others'];

export const DigitalAddressVerificationTypesArray = [
  DigitalAddressTypes.Permanent,
  DigitalAddressTypes.Current,
  DigitalAddressTypes.IntermediateOne,
  DigitalAddressTypes.IntermediateTwo
];

export const RelationshipTypesArray = [
  ConstantRelationshipTypes.Self,
  ConstantRelationshipTypes.BloodRelative,
  ConstantRelationshipTypes.Spouse,
  ConstantRelationshipTypes.Neighbour,
  ConstantRelationshipTypes.Other
];

export const OwnershipTypesArray = [
  ConstantOwnershipTypes.Rented,
  ConstantOwnershipTypes.Owned,
  ConstantOwnershipTypes.Leased,
  ConstantOwnershipTypes.PG,
  ConstantOwnershipTypes.Other
];

export const davVerificationStatusOptionsArray = [
  davStatusValues.Submitted,
  davStatusValues.Completed,
  davStatusValues.ReInitiated,
  davStatusValues.UnableToVerify,
  davStatusValues.Discrepancy,
  davStatusValues.Insufficient,
  davStatusValues.Wip,
  davStatusValues.Awaiting,
];

export const davVerificationStatusOptionsConfirmationArray = [
  davStatusValues.Completed,
  davStatusValues.UnableToVerify,
  davStatusValues.Discrepancy,
  davStatusValues.Insufficient
];

export const selectPortalUserOptions = [
  { value: PortalUserRoles.Admin, text: PortalUserRolesDisplayText.Admin },
  { value: PortalUserRoles.Client, text: PortalUserRolesDisplayText.Client },
  { value: PortalUserRoles.Sales, text: PortalUserRolesDisplayText.Sales },
  { value: PortalUserRoles.CstSupervisor, text: PortalUserRolesDisplayText.CstSupervisor },
  { value: PortalUserRoles.CstUser, text: PortalUserRolesDisplayText.CstUser },
  { value: PortalUserRoles.OpsSupervisor, text: PortalUserRolesDisplayText.OpsSupervisor },
  { value: PortalUserRoles.OpsTeam, text: PortalUserRolesDisplayText.OpsTeam },
  { value: PortalUserRoles.QualityControl, text: PortalUserRolesDisplayText.QualityControl },
  { value: PortalUserRoles.Accounts, text: PortalUserRolesDisplayText.Accounts }
];

export const calendarMonthsOptions = [
  { value: '', text: 'Select a month' },
  { value: '01', text: 'January' },
  { value: '02', text: 'February' },
  { value: '03', text: 'March' },
  { value: '04', text: 'April' },
  { value: '05', text: 'May' },
  { value: '06', text: 'June' },
  { value: '07', text: 'July' },
  { value: '08', text: 'August' },
  { value: '09', text: 'September' },
  { value: '10', text: 'October' },
  { value: '11', text: 'November' },
  { value: '12', text: 'December' },
];

export const calendarYearOptions = (() => {
  const startYear = 2025;
  const currentYear = new Date().getFullYear();
  const futureYears = 1; // Include 1 year ahead for planning
  
  const options = [{ value: '', text: 'Select a year' }];
  for (let year = startYear; year <= currentYear + futureYears; year++) {
    options.push({ value: String(year), text: String(year) });
  }
  return options;
})();

export const invoiceTypeOptions = [
  { value: "", label: "Select a type" },
  { value: invoiceTypes.Proforma, label: invoiceTypes.Proforma },
  { value: invoiceTypes.Commercial, label: invoiceTypes.Commercial },
]

export const TickMarkOptions = [
  bgvStatusValues.Completed,
  bgvStatusValues.BgvStop,
  bgvStatusValues.Discrepancy
];

export const assignedUnassignedOptions = [
  { value: "", label: "Select an option" },
  { value: "All", label: "All" },
  { value: "Assigned", label: "Assigned" },
  { value: "UnAssigned", label: "UnAssigned" },
]

export const qcApprovalOptions = [
  { value: "", label: "Select an option" },
  { value: "Final QC Approved", label: "Final QC Approved" },
  { value: "Interim QC Approved", label: "Interim QC Approved" },
  { value: "Final QC Rejected", label: "Final QC Rejected" },
  { value: "Interim QC Rejected", label: "Interim QC Rejected" },
  { value: "Final QC Review", label: "Final QC Review" },
  { value: "Interim QC Review", label: "Interim QC Review" },
  { value: "Awaiting", label: "Awaiting" }
]

export const clientBillingType = [
  { label: "Select an option", value: "", name: "Select an option" },
  { label: "Normal", value: "Normal", name: "Normal" },
  { label: "SEZ", value: "SEZ", name: "SEZ" },
  { label: "Export", value: "Export", name: "Export" },
];

export const companySize = [
  { label: "Select an option", value: "", name: "Select an option" },
  { label: "0 - 10", value: "0-10", name: "0 - 10" },
  { label: "11 - 50", value: "11-50", name: "11 - 50" },
  { label: "50 - 200", value: "50-200", name: "50 - 200" },
  { label: "200 - 500", value: "200-500", name: "200 - 500" },
  { label: "500 - 1000", value: "500-1000", name: "500 - 1000" },
  { label: "1000 - 5000", value: "1000-5000", name: "1000 - 5000" },
  { label: "5000 - 10000", value: "5000-10000", name: "5000 - 10000" },
  { label: "10000+", value: "10000+", name: "10000+" }
];

export const industryType = [
  { label: "Select an option", value: "", name: "Select an option" },
  { label: "IT", value: "IT", name: "IT" },
  { label: "BPO", value: "BPO", name: "BPO" },
  { label: "Manufacturing", value: "Manufacturing", name: "Manufacturing" },
  { label: "Healthcare", value: "Healthcare", name: "Healthcare" },
  { label: "BFSI", value: "BFSI", name: "BFSI" },
  { label: "Non IT", value: "Non IT", name: "Non IT" },
  { label: "Facility Management", value: "Facility Management", name: "Facility Management" },
  { label: "Staffing and Consulting", value: "Staffing and Consulting", name: "Staffing and Consulting" },
  { label: "Others", value: "Others", name: "Others" }
];


export const billingCurrencyArray = [
  { label: "Select an option", value: "", name: "Select an option" },
  { label: "USD", value: "USD", name: "USD" },
  { label: "GBP", value: "GBP", name: "GBP" },
  { label: "EUR", value: "EUR", name: "EUR" },
];